module.exports = __webpack_public_path__ + "static/media/forest_light_layer.b0cf1736.png";